import axiosInstance from './../axiosInstance';
import { buildParams } from '../buildParams';

/**
 * @name getScanPoints
 * @desc Get partner's scan points for an event.
 * @param {string} eventID
 * @param {string} partnerID
 * @param {object} params
 */
export const getScanPoints = (eventID, partnerID, params) => {
    const url = `events/${eventID}/partners/${partnerID}/scanPoints`;
    return axiosInstance.get(url, { params: buildParams(params) });
}


/**
 * @name getScanPoints
 * @desc Get single scanPoint by scanPointID.
 * @param {string} scanPointID
 */
export const getScanPoint = scanPointID => {
    const url = `scanPoints/${scanPointID}`;
    return axiosInstance.get(url);
}


/**
 * @name getScans
 * @desc Get scans of a scan point.
 * @param {string} scanPointID
 * @param {object} params
 */
export const getScans = (scanPointID, params) => {
    const url = `scanPoints/${scanPointID}/scans`;
    return axiosInstance.get(url, {params: params});
}


/**
 * @name saveScanPoint
 * @desc Save scan point. *
 * @param {object} scanPoint
 */
export const saveScanPoint = scanPoint => {
    const url = `scanPoints/${scanPoint.scanPointID}`;
    return axiosInstance.post(url, scanPoint);
}

/**
 * @name orderScanPoints
 * @desc Order scanpoint(s).
 * @param {Array} scanPoints
 */
export const orderScanPoints = (eventID, scanPoints) => {
    const url = `events/${eventID}/scanPoints`;
    return axiosInstance.post(url, { scanPoints });
}

/**
 * @name downloadScansAsXlsx
 * @desc download scans from a scanpoint in xlsx format for exporting
 * @param {string} scanPointID
 */
export const downloadScansAsXlsx = scanPointID => {
    const url = `scanPoints/${scanPointID}/scans?format=xlsx`;
    return axiosInstance.get(url, { responseType: 'arraybuffer' });
}